<footer class="footer-area pt-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="content">
                    <div class="logo">
                        <a routerLink="/"><img src="assets/images/logo2.png" alt="logo" /></a>
                    </div>
                    

                    <div class="subscribe">
                        <!-- <h4>Join Newsletter</h4> -->
                        <!-- <form class="newsletter-form">
                            <input type="email" id="emails" class="form-control" placeholder="Your Email" name="EMAIL" required autocomplete="off">
                            <button class="box-btn" type="submit">Subscribe</button>
                        </form> -->
                    </div>
                    <br>
                    <br>
                    <br>

                    <ul class="social">
                        <li><a href="#" target="_blank"><i class='bx bxl-facebook' ></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-twitter' ></i></a></li>
                        <li><a href="#" target="_blank"><i class='bx bxl-instagram' ></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="content ml-15">
                    <h3>Employer Paid Benefits</h3>

                    <ul class="footer-list">
                        <!-- <li><a routerLink="/">Visual Design</a></li>
                        <li><a routerLink="/"> Development</a></li>
                        <li><a routerLink="/">QA & Testing</a></li>
                        <li><a routerLink="/">IT Management</a></li>
                        <li><a routerLink="/">Cyber Security</a></li>
                        <li><a routerLink="/">Wireless Connection</a></li> -->
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-6">
                <div class="content">
                    <h3>Voluntary Benefits</h3>

                    <ul class="footer-list">
                        <!-- <li><a routerLink="/faq">FAQ</a></li>
                        <li><a routerLink="/solutions">Service</a></li>
                        <li><a routerLink="/">Career</a></li>
                        <li><a routerLink="/privecy">Privacy & Policy</a></li>
                        <li><a routerLink="/terms-condition">Terms & Conditions</a></li>
                        <li><a routerLink="/">Data Analysis</a></li> -->
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6">
                <div class="content contacts">
                    <h3 class="ml-40">Contact Us</h3>

                    <ul class="footer-list foot-social">
                        <li><a href="tel:+1123456789"><i class="bx bx-mobile-alt"></i> +1 (844) 387-4782</a></li>
                        <li><a href="mailto:support@aiva.com"><i class="bx bxs-envelope"></i>info@tristatebenefits.nyc</a></li>
                        <li><i class="bx bxs-map"></i>9920 Fourth Avenue, Suite 310, Brooklyn, NY 11209</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="copy-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <ul class="menu">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/about">About</a></li>
                        <li><a routerLink="/solutions">Services</a></li>
                        <li><a routerLink="/case">Our Team</a></li>
                        <!-- <li><a routerLink="/blog">Blog</a></li> -->
                        <li><a routerLink="/contact">Contact Us</a></li>
                    </ul>
                </div>

                <div class="col-lg-6">
                    <p>©2023 <a href="https://hibootstrap.com/" target="_blank">Tristate Union Benefits</a></p>
                </div>
            </div>
        </div>
    </div>
</footer>

<div class="go-top">
    <i class='bx bx-chevrons-up'></i>
    <i class='bx bx-chevrons-up'></i>
</div>